import { useState, useEffect, useRef } from 'react';
import { fetchPartners } from '../api/api';
import styles from '../styles/components/_Partners.module.scss';

const Partners = () => {
  const [partners, setPartners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const sliderRef = useRef(null);
  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    const loadPartners = async () => {
      try {
        setIsLoading(true);
        const response = await fetchPartners();
        
        // L'API renvoie maintenant les URLs correctement, nous pouvons les utiliser directement
        const partnersWithLogos = response.map(partner => ({
          ...partner,
          logoUrl: partner?.acf?.logo?.url || null,
          title: partner.title?.rendered || 'Partenaire'
        }));
        
        setPartners(partnersWithLogos);
      } catch (err) {
        console.error('Erreur lors du chargement des partenaires:', err);
        setError('Erreur lors du chargement des partenaires');
      } finally {
        setIsLoading(false);
      }
    };

    loadPartners();
  }, []);

  // Activer l'animation une fois que les images sont chargées
  useEffect(() => {
    if (!isLoading && partners.length > 0) {
      // Attendre un court instant pour s'assurer que le DOM est prêt
      const timer = setTimeout(() => {
        setStartAnimation(true);
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [isLoading, partners]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-600 text-center p-4">
        {error}
      </div>
    );
  }

  // Vérification si nous avons des partenaires
  if (!partners || partners.length === 0) {
    return null;
  }

  // Filtrer les partenaires sans logo
  const validPartners = partners.filter(partner => partner.logoUrl);

  if (validPartners.length === 0) {
    return <div className="text-white text-center p-4">Partenaires indisponibles</div>;
  }

  return (
    <div className={styles['partners-container']}>
      <h2 className="text-white text-center text-2xl mb-4">Nos Partenaires</h2>
      <div className={styles['partners-slider']} ref={sliderRef}>
        <div 
          className={`${styles['partners-slider-content']} ${startAnimation ? styles['animate'] : ''}`}
          style={{ 
            width: `${validPartners.length * 160}px`,
            animationPlayState: startAnimation ? 'running' : 'paused' 
          }}
        >
          {validPartners.map((partner) => (
            <div 
              key={partner.id} 
              className={styles['partners-item']}
            >
              <img
                src={partner.logoUrl}
                alt={partner.title}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          ))}
          {/* Répète les logos pour un défilement continu */}
          {validPartners.map((partner) => (
            <div 
              key={`copy-${partner.id}`} 
              className={styles['partners-item']}
            >
              <img 
                src={partner.logoUrl} 
                alt={partner.title} 
                onError={(e) => e.target.style.display = 'none'}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
